(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boden10-ads-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    var dialog = document.getElementById('bp-boden10-dialog');
    if (!dialog || !dialog.showModal) return;
    var now = Date.now();
    if (now < Date.parse('2026-10-02T00:00:00Z') || now >= Date.parse('2026-10-18T21:59:00Z')) return;
    if (!/^\/(collections|products)(\/|$)/.test(location.pathname) && location.pathname !== '/') return;
    try {
      if (localStorage.getItem('bp_auto10_20261002_seen') === '1' || localStorage.getItem('bp_auto10_20261002_dismissed') === '1') return;
    } catch (error) {
      try { if (sessionStorage.getItem('bp_auto10_20261002_seen') === '1') return; } catch (ignored) {}
    }
    var opened = false;
    function open() {
      if (opened || document.hidden || dialog.open) return;
      opened = true;
      try { localStorage.setItem('bp_auto10_20261002_seen', '1'); } catch (error) {
        try { sessionStorage.setItem('bp_auto10_20261002_seen', '1'); } catch (ignored) {}
      }
      dialog.showModal();
      window.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      if (window.scrollY > Math.min(220, document.documentElement.scrollHeight * .12)) open();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(open, 6500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bodenpulse-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-back-to-top')) {
    customElements.define('bp-back-to-top', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const button = this.querySelector('button');
        if (!button) return;
        const update = () => {
          this.frame = null;
          button.hidden = window.scrollY < Math.min(400, window.innerHeight * 0.6);
        };
        const schedule = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', schedule, {passive:true, signal:this.controller.signal});
        window.addEventListener('resize', schedule, {passive:true, signal:this.controller.signal});
        button.addEventListener('click', () => {
          document.querySelector('.skip-to-content-link')?.focus({preventScroll:true});
          window.scrollTo({top:0, left:0, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal:this.controller.signal});
        // v3 Ladezeit 01.11.: erster Scroll-Check im nächsten Frame statt sofort (kein erzwungenes Layout beim Start)
        schedule();
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.frame != null) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bodenpulse-bild-hinweise"] && !Shopify.designMode) return;
  try {
    /* Nora 31.10. v9: Störer einmalig einblenden (300 ms), Kachel per IntersectionObserver, Variantenupdate */
(function () {
  if (window.bpHinweise) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  function play(el) { if (!reduce && el) el.classList.add('is-in'); }
  function init(root) {
    root = root || document;
    root.querySelectorAll('.bp-hinweise--pdp .bp-stoerer:not([data-bp-init])').forEach(function (el) {
      el.setAttribute('data-bp-init', '1');
      if (!el.hidden) play(el);
    });
    var cards = root.querySelectorAll('.bp-hinweise--card .bp-stoerer:not([data-bp-init])');
    if (!cards.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      cards.forEach(function (el) { el.setAttribute('data-bp-init', '1'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { play(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
    }
    cards.forEach(function (el) { el.setAttribute('data-bp-init', '1'); io.observe(el); });
  }
  function update(scope, priceCents, compareCents, available) {
    var root = scope && scope.querySelector('.bp-hinweise--pdp');
    if (!root) return;
    var st = root.querySelector('[data-bp-stoerer]');
    var price = Number(priceCents) || 0, compare = Number(compareCents) || 0;
    var pct = compare > price && compare > 0 ? Math.floor((compare - price) * 100 / compare) : 0;
    var show = root.getAttribute('data-aus') !== 'true' && pct >= 5;
    root.hidden = available === false;
    root.classList.toggle('has-stoerer', show);
    if (st) {
      var out = st.querySelector('[data-bp-stoerer-pct]');
      if (out) out.textContent = String(pct);
      var wasHidden = st.hidden;
      st.hidden = !show;
      if (show && wasHidden) { st.classList.remove('is-in'); void st.offsetWidth; play(st); }
    }
    return pct;
  }
  window.bpHinweise = { init: init, update: update };
  function start() {
    init(document);
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { init(document); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bodenpulse-estimated-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-estimated-delivery')) {
    customElements.define('bp-estimated-delivery', class extends HTMLElement {
      connectedCallback() {
        const deliveryTime = this.dataset.deliveryTime || '';
        const businessDays = deliveryTime.match(/\d+/g);
        const dateNode = this.querySelector('[data-bp-delivery-date]');

        const usesBusinessDays = /\b(?:werk|arbeits)tage?\b/i.test(deliveryTime);

        if (!dateNode || this.dataset.available !== 'true' || !businessDays || !usesBusinessDays) {
          if (dateNode && this.dataset.available !== 'true') {
            dateNode.textContent = this.dataset.unavailable;
          }
          return;
        }

        const maximumDays = Number.parseInt(businessDays.at(-1), 10);
        if (!Number.isFinite(maximumDays) || maximumDays < 1) return;

        const today = this.berlinToday();
        const deliveryDate = this.addBusinessDays(today, maximumDays);
        const formattedDate = new Intl.DateTimeFormat('de-DE', {
          timeZone: 'Europe/Berlin',
          weekday: 'short',
          day: 'numeric',
          month: 'long'
        }).format(deliveryDate);

        dateNode.textContent = `${this.dataset.untilPrefix} ${formattedDate}`;
      }

      berlinToday() {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Berlin',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());
        const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
        return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
      }

      addBusinessDays(startDate, amount) {
        const date = new Date(startDate);
        let added = 0;

        while (added < amount) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (this.isBusinessDay(date)) added += 1;
        }

        return date;
      }

      isBusinessDay(date) {
        const weekday = date.getUTCDay();
        if (weekday === 0 || weekday === 6) return false;
        return !this.holidays(date.getUTCFullYear()).has(this.dateKey(date));
      }

      holidays(year) {
        const easter = this.easterSunday(year);
        const movingHoliday = (offset) => {
          const date = new Date(easter);
          date.setUTCDate(date.getUTCDate() + offset);
          return this.dateKey(date);
        };

        return new Set([
          `${year}-01-01`,
          movingHoliday(-2),
          movingHoliday(1),
          `${year}-05-01`,
          movingHoliday(39),
          movingHoliday(50),
          `${year}-10-03`,
          `${year}-12-25`,
          `${year}-12-26`
        ]);
      }

      easterSunday(year) {
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(Date.UTC(year, month - 1, day, 12));
      }

      dateKey(date) {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bodenpulse-mobile-purchase-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-mobile-purchase-bar')) {
    customElements.define('bp-mobile-purchase-bar', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(this.dataset.rootId || '');
        this.trigger = this.querySelector('[data-bp-mobile-purchase-trigger]');
        this.titleNode = this.querySelector('[data-bp-mobile-purchase-title]');
        this.subtitleNode = this.querySelector('[data-bp-mobile-purchase-subtitle]');
        this.primary = this.root?.querySelector('[data-bp-add], [data-bp-accessory-add]');
        this.focusTarget = this.root?.querySelector('[data-bp-area], [data-bp-accessory-area], .bp-floor-main__package-quantity input');

        if (!this.root || !this.trigger || !this.primary) return;

        this.sampleTrigger = this.querySelector('[data-bp-mobile-sample]');
        this.handleSample = () => this.root.querySelector('[data-bp-sample]')?.click();
        this.sampleTrigger?.addEventListener('click', this.handleSample);
        if (this.sampleTrigger && !this.root.querySelector('[data-bp-sample]')) this.sampleTrigger.hidden = true;
        this.roomTrigger = this.querySelector('[data-bp-mobile-room]');
        this.handleRoom = () => this.root.querySelector('.bp-room-open')?.click();
        this.roomTrigger?.addEventListener('click', this.handleRoom);
        this.setupOrderDialog();

        this.hidden = false;
        this.handleClick = () => this.activate();
        this.handleStateChange = () => window.requestAnimationFrame(() => this.sync());
        this.trigger.addEventListener('click', this.handleClick);
        this.root.addEventListener('input', this.handleStateChange);
        this.root.addEventListener('change', this.handleStateChange);
        this.root.addEventListener('click', this.handleStateChange);
        this.root.addEventListener('bp:stock-call', this.handleStateChange);

        this.contentObserver = new MutationObserver(() => this.sync());
        this.contentObserver.observe(this.primary, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true
        });

        // Nora 31.10. (v4): Der Seiten-Button gilt nur als sichtbar, wenn er unterhalb des festen Headers liegt.
        // rootMargin oben = Header-Höhe (Fallback 95 px), bei Größenänderung neu berechnet.
        this.observePrimary();
        this.handleResize = () => {
          window.clearTimeout(this.resizeTimer);
          this.resizeTimer = window.setTimeout(() => this.observePrimary(), 150);
        };
        window.addEventListener('resize', this.handleResize);
        if (this.root.hasAttribute('data-bp-direct-purchase')) {
          this.localControlsObserver = new IntersectionObserver(entries => {
            for (const entry of entries) {
              if (entry.target.hasAttribute('data-bp-accessory-project-area')) this.localAreaVisible = entry.isIntersecting;
              if (entry.target.hasAttribute('data-bp-project-add')) this.localPurchaseVisible = entry.isIntersecting;
            }
            this.syncVisibility();
          }, { threshold: .5 });
          this.root.querySelectorAll('[data-bp-accessory-project-area], [data-bp-project-add]').forEach(node => this.localControlsObserver.observe(node));
        }


        this.overlayObserver = new MutationObserver(() => this.syncVisibility());
        this.overlayObserver.observe(document.documentElement, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class', 'open', 'aria-hidden']
        });

        this.sync();
      }

      // Nora 31.10. (Selin 19:36, Punkt 3): echte Kopfhöhe – Unterkante aller festen/klebenden Kopf-Elemente, die gerade oben sichtbar sind
      // (Ankündigungsleiste + Header; ein beim Scrollen ausgeblendeter Header zählt nicht). Fallback 95 px nur ohne Kopf-Element.
      headerOffset() {
        let bottom = 0;
        let found = false;
        document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group > *, .section-header, sticky-header, .header-wrapper, header, .announcement-bar-section, .utility-bar').forEach((node) => {
          found = true;
          const position = getComputedStyle(node).position;
          if (position !== 'sticky' && position !== 'fixed') return;
          const rect = node.getBoundingClientRect();
          if (rect.height > 0 && rect.top <= 1 && rect.bottom > bottom && rect.bottom < window.innerHeight / 2) bottom = rect.bottom;
        });
        return found ? Math.max(0, Math.round(bottom)) : 95;
      }

      // Seiten-Button zählt erst als sichtbar, wenn >= 60 % seiner Höhe unter dem Kopf liegen und davon mindestens 44 px
      // (Tippfläche). Bei 48 px Button: Leiste sichtbar, solange weniger als 44 px frei sind (Lücke 29–41 px abgedeckt).
      primaryVisibleNow() {
        const target = this.inlineTrigger || this.primary;
        if (!target || !target.getClientRects().length) return false;
        const rect = target.getBoundingClientRect();
        if (!rect.height) return false;
        const seen = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, this.headerOffset());
        return seen >= rect.height * .6 && seen >= Math.min(44, rect.height);
      }

      updatePrimaryVisibility() {
        const visible = this.primaryVisibleNow();
        if (visible === this.primaryIsVisible) return;
        this.primaryIsVisible = visible;
        this.syncVisibility();
      }

      observePrimary() {
        this.visibilityObserver?.disconnect();
        this.headerMargin = `-${this.headerOffset()}px 0px 0px 0px`;
        // IntersectionObserver mit echter Kopfhöhe als rootMargin; Entscheidung über primaryVisibleNow (Kopfhöhe live gemessen)
        this.visibilityObserver = new IntersectionObserver(() => {
          this.primaryIsVisible = this.primaryVisibleNow();
          this.syncVisibility();
        }, { threshold: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1], rootMargin: this.headerMargin });
        this.visibilityObserver.observe(this.inlineTrigger || this.primary);
        if (!this.handleScrollVisibility) {
          this.handleScrollVisibility = () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.updatePrimaryVisibility(); });
          };
          window.addEventListener('scroll', this.handleScrollVisibility, { passive: true });
        }
      }

      updateBarPrice() {
        if (!this.priceNode) this.priceNode = this.querySelector('[data-bp-mobile-purchase-price]');
        const perArea = this.root?.querySelector('.bp-floor-main__m2-price > strong');
        if (!this.priceNode || !perArea || this.dataset.contextType !== 'floor') return;
        const text = perArea.textContent.trim();
        if (!text) return;
        if (this.priceNode.dataset.value !== text) {
          const value = document.createElement('strong');
          value.textContent = text;
          const unit = document.createElement('small');
          unit.textContent = 'pro m²';
          this.priceNode.replaceChildren(value, unit);
          this.priceNode.dataset.value = text;
        }
        this.priceNode.hidden = false;
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        if (this.handleScrollVisibility) window.removeEventListener('scroll', this.handleScrollVisibility);
        this.sampleTrigger?.removeEventListener('click', this.handleSample);
        this.roomTrigger?.removeEventListener('click', this.handleRoom);
        this.roomObserver?.disconnect();
        this.closeOrderDialog();
        this.restoreOrderContent();
        this.mediaQuery?.removeEventListener('change', this.handleViewportChange);
        this.root?.removeEventListener('bp:floor-added', this.handleAdded);
        this.form?.removeEventListener('submit', this.handleAccessorySubmit);
        this.dialog?.remove();
        this.inlineTrigger?.remove();
        this.calculatorAnchor?.remove();
        this.formAnchor?.remove();
        this.roomAnchors?.forEach((anchor, node) => {
          if (anchor.isConnected) anchor.after(node);
          anchor.remove();
        });
        this.trigger?.removeEventListener('click', this.handleClick);
        this.root?.removeEventListener('input', this.handleStateChange);
        this.root?.removeEventListener('change', this.handleStateChange);
        this.root?.removeEventListener('click', this.handleStateChange);
        this.contentObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.localControlsObserver?.disconnect();
        this.overlayObserver?.disconnect();
      }

      syncVisibility() {
        const overlayOpen = document.documentElement.classList.contains('bp-floor-modal-open')
          || document.documentElement.classList.contains('bp-order-dialog-open')
          || !!document.querySelector('dialog[open], cart-drawer.active, .bp-floor-build.is-open, .bp-floor-lightbox.is-open');
        // 31.10. (Nora, nach Variante A 30.10.): Leiste nie zeigen, solange der eigene Kauf-Button der Seite sichtbar ist –
        // auch nicht bei triple / always_visible (vorher erzwungen sichtbar -> zwei gleiche Buttons übereinander).
        this.dataset.visible = String(!overlayOpen && !this.primaryIsVisible && (this.dataset.triple === 'true' || this.dataset.alwaysVisible === 'true' || (!this.localAreaVisible && !this.localPurchaseVisible)));
      }

      numberValue(input) {
        const normalized = String(input?.value || '')
          .trim()
          .replace(/\s/g, '')
          .replace(',', '.');

        return Number.parseFloat(normalized) || 0;
      }

      isConfigured() {
        const activeFloorMode = this.root.querySelector('[data-bp-calculator-mode].is-active');

        if (activeFloorMode) {
          if (activeFloorMode.dataset.bpCalculatorMode === 'packages') {
            return this.numberValue(this.root.querySelector('.bp-floor-main__package-quantity input')) > 0;
          }

          return this.numberValue(this.root.querySelector('[data-bp-area]')) > 0;
        }

        const accessoryMode = this.root.querySelector('[data-bp-accessory-mode].is-active');
        if (accessoryMode?.dataset.bpAccessoryMode === 'quantity' || this.root.querySelector('[data-bp-accessory-quantity]')?.dataset.manual === 'true') {
          return this.numberValue(this.root.querySelector('[data-bp-accessory-quantity]')) > 0;
        }

        const accessoryArea = this.root.querySelector('[data-bp-accessory-area]');

        if (accessoryArea) {
          if (this.numberValue(accessoryArea) <= 0) return false;

          const thickness = this.root.querySelector('[data-bp-accessory-thickness]');
          if (thickness && this.numberValue(thickness) <= 0) return false;
        }

        return true;
      }

      sync() {
        this.updateBarPrice();
        // Nora 31.10. (v7, Selin 19:16): ohne Mengendialog spiegelt die Leiste den gesperrten Bestandszustand („Jetzt anrufen“, tel:)
        // v7.6 (19:21): auch auf Zubehörseiten – überall dort, wo die Leiste direkt in den Warenkorb legt (kein Dialog, Desktop oder aktives Projekt)
        const stockCall = this.directPurchase() && this.root.dataset.bpStockCall === 'true' ? this.root.querySelector('[data-bp-stock-call]:not([hidden])') : null;
        if (stockCall) {
          this.dataset.mode = 'call';
          this.trigger.disabled = false;
          this.trigger.setAttribute('aria-label', stockCall.getAttribute('aria-label') || 'Jetzt anrufen');
          this.titleNode.textContent = 'Jetzt anrufen';
          this.subtitleNode.textContent = '';
          return;
        }
        this.trigger.removeAttribute('aria-label');
        // v7.6: Anruf-Modus nicht stehen lassen, wenn die Menge wieder passt (Dialog-Zweig setzt keinen eigenen Modus)
        if (this.dataset.mode === 'call') delete this.dataset.mode;
        if (this.root.dataset.bpCartProjectActive === 'true' && this.isConfigured()) {
          this.titleNode.textContent = this.primary.querySelector('strong')?.textContent.trim() || '';
          this.subtitleNode.textContent = this.primary.querySelector('small')?.textContent.trim() || '';
          this.trigger.disabled = this.primary.disabled;
          if (this.inlineTrigger) this.inlineTrigger.textContent = this.titleNode.textContent;
          this.syncVisibility();
          return;
        }
        if (this.dialog) {
          this.moveRoomEntryOutside();
          this.updateDialogPrice();
          this.titleNode.textContent = this.dataset.buyTitle;
          const isAvailable = !this.primary.disabled && this.primary.getAttribute('aria-disabled') !== 'true';
          this.trigger.disabled = !isAvailable;
          this.syncVisibility();
          // Nora 31.10. (v7.9, Live-Befund 19:52): im Sperrzustand keine Menge/kein Betrag über dem Bestand in der Leiste
          const stockLocked = this.root.dataset.bpStockCall === 'true';
          this.subtitleNode.textContent = this.isConfigured() && !stockLocked
            ? this.primary.querySelector('small')?.textContent.trim() || this.dataset.buyHelp
            : stockLocked ? 'Menge über Lagerbestand – bitte anrufen' : this.dataset.buyHelp;
          if (this.inlineTrigger) {
            this.inlineTrigger.disabled = !isAvailable;
            this.inlineTrigger.textContent = this.dataset.buyTitle;
          }
          return;
        }
        const isReady = !this.primary.disabled && this.primary.getAttribute('aria-disabled') !== 'true';
        const primaryTitle = this.primary.querySelector('strong')?.textContent.trim();
        const primarySubtitle = this.primary.querySelector('small')?.textContent.trim();

        if (isReady && this.isConfigured()) {
          this.dataset.mode = 'cart';
          this.trigger.disabled = false;
          this.titleNode.textContent = this.dataset.triple === 'true' ? this.dataset.cartShort : primaryTitle || this.dataset.calculateTitle;
          this.subtitleNode.textContent = primarySubtitle || '';
          return;
        }

        if (this.focusTarget) {
          this.dataset.mode = 'calculate';
          this.trigger.disabled = false;
          this.titleNode.textContent = this.dataset.calculateTitle;
          this.subtitleNode.textContent = this.dataset.calculateHelp;
          return;
        }

        this.dataset.mode = 'unavailable';
        this.trigger.disabled = true;
        this.titleNode.textContent = primaryTitle || this.dataset.unavailable;
        this.subtitleNode.textContent = primarySubtitle || '';
      }

      // Nora 31.10. (v7.6): legt die Leiste direkt in den Warenkorb (statt den Mengendialog zu öffnen)?
      directPurchase() {
        return !this.dialog || this.root.dataset.bpCartProjectActive === 'true' || (this.mediaQuery ? !this.mediaQuery.matches : false);
      }

      activate() {
        if (this.dataset.mode === 'call' && this.directPurchase()) {
          const stockCall = this.root.querySelector('[data-bp-stock-call]');
          if (stockCall) { window.location.href = stockCall.getAttribute('href'); return; }
        }
        if (this.root.dataset.bpCartProjectActive === 'true' && this.isConfigured()) {
          this.primary.click();
          return;
        }
        if (this.dialog) {
          this.openOrderDialog();
          return;
        }
        if (this.dataset.mode === 'cart') {
          this.primary.click();
          return;
        }

        if (!this.focusTarget) return;

        if (this.root.hasAttribute('data-bp-direct-purchase')) {
          const candidates = Array.from(this.root.querySelectorAll('[data-bp-area], [data-bp-accessory-project-area]'))
            .filter(input => input.getClientRects().length);
          candidates.sort((a, b) => Math.abs(a.getBoundingClientRect().top - window.innerHeight / 2) - Math.abs(b.getBoundingClientRect().top - window.innerHeight / 2));
          this.focusTarget = candidates[0] || this.focusTarget;
        }
        this.focusTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => this.focusTarget.focus({ preventScroll: true }), 420);
      }

      setupOrderDialog() {
        if (this.dataset.contextType === 'floor' && this.root.hasAttribute('data-bp-direct-purchase') && !this.root.hasAttribute('data-bp-panorama-purchase')) return;
        this.calculator = this.root.querySelector('.bp-floor-main__calculator,.bp-accessory-main__calculator');
        this.form = this.root.querySelector('.bp-floor-main__form,product-form');
        if (!this.form || !window.HTMLDialogElement) return;
        if (!this.calculator) {
          this.calculator = document.createElement('div');
          this.calculator.hidden = true;
          this.form.before(this.calculator);
        }

        this.calculatorAnchor = document.createElement('span');
        this.formAnchor = document.createElement('span');
        this.calculator.before(this.calculatorAnchor);
        this.form.before(this.formAnchor);
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'bp-order-dialog';
        this.dialog.id = `${this.dataset.rootId}-order-dialog`;
        const header = document.createElement('div');
        header.className = 'bp-order-dialog__head';
        const title = document.createElement('h2');
        title.id = `${this.dialog.id}-title`;
        title.textContent = this.dataset.dialogTitle;
        title.tabIndex = -1;
        this.dialogTitle = title;
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'bp-order-dialog__close';
        close.setAttribute('aria-label', this.dataset.closeLabel);
        close.textContent = '×';
        close.addEventListener('click', () => this.closeOrderDialog());
        header.append(title, close);
        this.dialog.setAttribute('aria-labelledby', title.id);
        const name = document.createElement('p');
        name.className = 'bp-order-dialog__product';
        name.textContent = this.root.querySelector('h1')?.textContent.trim() || '';
        this.dialogPrice = document.createElement('div');
        this.dialogPrice.className = 'bp-order-dialog__price';
        this.dialogContent = document.createElement('div');
        this.dialogContent.className = 'bp-order-dialog__content';
        this.dialog.append(header, name, this.dialogPrice, this.dialogContent);
        const taxNote = this.root.querySelector('.bp-tax-shipping-note');
        if (taxNote) {
          // Nora 31.10. (v4): im Dialog kurz „zzgl. Versand“ (Betrag steht unten am Gesamtpreis); „inkl. 19 % MwSt.“ bleibt
          const dialogTaxNote = taxNote.cloneNode(true);
          dialogTaxNote.querySelectorAll('a').forEach((link) => {
            if (/Versandkosten/.test(link.textContent)) link.textContent = link.textContent.replace('Versandkosten', 'Versand');
          });
          this.dialogPrice.after(dialogTaxNote);
        }
        this.root.append(this.dialog);
        this.roomObserver = new MutationObserver(() => this.moveRoomEntryOutside());
        this.roomObserver.observe(this.form, { childList: true, subtree: true });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('bp-order-dialog-open');
          if (!this.mediaQuery.matches) this.restoreOrderContent();
          this.syncVisibility();
        });
        this.dialog.addEventListener('click', (event) => {
          const jump = event.target.closest('.bp-floor-accessories__jump');
          if (jump) {
            const id = jump.getAttribute('href')?.slice(1);
            const target = id && document.getElementById(id);
            if (!target) return;
            event.preventDefault();
            this.closeOrderDialog();
            document.documentElement.classList.remove('bp-order-dialog-open');
            requestAnimationFrame(() => {
              target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
            });
            return;
          }
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeOrderDialog();
        });
        this.inlineTrigger = document.createElement('button');
        this.inlineTrigger.type = 'button';
        this.inlineTrigger.className = 'bp-order-dialog__inline-trigger';
        this.inlineTrigger.textContent = this.dataset.buyTitle;
        this.inlineTrigger.setAttribute('aria-haspopup', 'dialog');
        this.inlineTrigger.setAttribute('aria-controls', this.dialog.id);
        this.inlineTrigger.addEventListener('click', () => {
          if (this.root.dataset.bpCartProjectActive === 'true' && this.isConfigured()) this.primary.click();
          else this.openOrderDialog();
        });
        this.calculatorAnchor.before(this.inlineTrigger);
        // Nora 31.10. (v7.7): Beratungsblock mobil direkt unter dem Inline-Button (Desktop: per CSS ausgeblendet)
        const advisorTemplate = this.querySelector('template[data-bp-advisor-template]');
        this.advisorCompact = advisorTemplate?.content.firstElementChild ? advisorTemplate.content.firstElementChild.cloneNode(true) : null;
        if (this.advisorCompact) this.inlineTrigger.after(this.advisorCompact);
        this.syncAdvisorOrder();
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.roomAnchors = new Map();
        this.handleAdded = () => this.closeOrderDialog();
        this.root.addEventListener('bp:floor-added', this.handleAdded);
        this.root.addEventListener('bp:project-started', this.handleAdded);
        this.handleAccessorySubmit = () => {
          if (this.dataset.contextType !== 'floor' && this.isConfigured()) this.closeOrderDialog();
        };
        this.form.addEventListener('submit', this.handleAccessorySubmit);
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.handleViewportChange = () => {
          if (this.mediaQuery.matches) {
            this.dialogContent.append(this.calculator, this.form);
          } else {
            this.closeOrderDialog();
            this.restoreOrderContent();
          }
          this.moveRoomEntryOutside();
          this.syncVisibility();
        };
        this.mediaQuery.addEventListener('change', this.handleViewportChange);
        this.handleViewportChange();
      }

      restoreOrderContent() {
        if (this.calculatorAnchor?.isConnected) this.calculatorAnchor.after(this.calculator);
        if (this.formAnchor?.isConnected) this.formAnchor.after(this.form);
      }

      // v7.7-Korrektur: der Inline-Button hat mobil eine CSS-Reihenfolge (order 4) – der Block übernimmt sie, sonst stand er darüber
      // v3 Ladezeit 01.11.: Reihenfolge kommt jetzt per CSS (siehe Stylesheet-Block oben), kein getComputedStyle mehr (erzwang bei jeder Formular-Änderung eine Style-Berechnung)
      syncAdvisorOrder() {}

      moveRoomEntryOutside() {
        this.syncAdvisorOrder();
        if (!this.form || !this.inlineTrigger || !this.mediaQuery) return;
        if (this.mediaQuery.matches) {
          this.form.querySelectorAll('[data-bp-room-embed]').forEach((node) => {
            if (!this.roomAnchors.has(node)) {
              const anchor = document.createElement('span');
              node.before(anchor);
              this.roomAnchors.set(node, anchor);
            }
            (this.advisorCompact || this.inlineTrigger).after(node);
          });
        } else {
          this.roomAnchors.forEach((anchor, node) => {
            if (anchor.isConnected && node.previousElementSibling !== this.primary) this.primary.after(node);
          });
        }
      }

      updateDialogPrice() {
        if (this.dataset.contextType !== 'floor') {
          const price = this.root.querySelector('[data-bp-accessory-price]');
          const source = this.root.querySelector('[data-bp-accessory-price-box]');
          if (source) {
            const block = source.cloneNode(true);
            for (const node of [block, ...block.querySelectorAll('*')]) {
              for (const attribute of [...node.attributes]) {
                if (attribute.name === 'id' || attribute.name.startsWith('data-bp-')) node.removeAttribute(attribute.name);
              }
            }
            this.dialogPrice.replaceChildren(block);
          } else {
            this.dialogPrice.textContent = price?.textContent.trim() || '';
          }
          return;
        }
        const price = this.root.querySelector('[data-bp-package-price]');
        const perArea = this.root.querySelector('.bp-floor-main__m2-price > strong');
        this.dialogPrice.textContent = [
          perArea ? `${perArea.textContent.trim()} / m²` : '',
          price ? `${this.root.querySelector('.bp-floor-main__package-price > span')?.textContent.trim() || ''} ${price.textContent.trim()}` : ''
        ].filter(Boolean).join(' · ');
      }

      openOrderDialog() {
        if (!this.mediaQuery.matches || this.dialog.open) return;
        this.dialogContent.append(this.calculator, this.form);
        this.moveRoomEntryOutside();
        this.updateDialogPrice();
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
        // 31.10. (Nora): Beim Öffnen direkt ins Flächenfeld (Tastatur öffnet im selben Tipp), sonst Titel wie bisher.
        const areaField = this.dataset.contextType === 'floor'
          ? this.root.querySelector('[data-bp-calculator-mode].is-active')?.dataset.bpCalculatorMode === 'packages'
            ? this.root.querySelector('.bp-floor-main__package-quantity input')
            : this.root.querySelector('[data-bp-area]')
          : null;
        if (areaField && areaField.getClientRects().length && !areaField.value) areaField.focus({ preventScroll: true });
        else this.dialogTitle.focus({ preventScroll: true });
        document.documentElement.classList.add('bp-order-dialog-open');
        this.dataset.visible = 'false';
      }

      closeOrderDialog() {
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bodenpulse-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Nora 01.11. Bildgroessen: Zweitbild der Karte erst laden, wenn es gebraucht wird */
    if (window.BpCardSecondInit) return;
    window.BpCardSecondInit = true;
    const load = (g) => {
      const i = g && g.querySelector('img.bp-card-gallery__second[data-bp-src]');
      if (!i) return;
      if (i.dataset.bpSrcset) i.srcset = i.dataset.bpSrcset;
      i.src = i.dataset.bpSrc;
      i.removeAttribute('data-bp-src');
      i.removeAttribute('data-bp-srcset');
    };
    const onEv = (e) => {
      const t = e.target;
      if (!t || !t.closest) return;
      if (e.type === 'pointerover' && e.pointerType !== 'mouse') return;
      const zone = e.type === 'pointerover' ? t.closest('.bp-card-gallery') : t.closest('.bp-card-gallery__switch');
      if (zone) load(zone.closest('.bp-card-gallery'));
    };
    ['pointerover', 'pointerdown', 'touchstart', 'focusin', 'change'].forEach((ev) => document.addEventListener(ev, onEv, { passive: true, capture: true }));
  })();



  (() => {
    if (window.BodenpulseProductCardSamplesInitialized) {
      return;
    }

    window.BodenpulseProductCardSamplesInitialized = true;

    const root =
      window.Shopify?.routes?.root || '/';

    const cartUrl =
      `${root}cart.js`;

    const cartAddUrl =
      `${root}cart/add.js`;


    const getMessageElement = (button) => {
      const footer =
        button.closest(
          '.bp-product-card__footer'
        );

      return footer?.querySelector(
        '[data-bp-card-sample-message]'
      );
    };


    const setButtonLabel = (
      button,
      text
    ) => {
      const label =
        button.querySelector(
          '[data-bp-card-sample-label]'
        );

      if (label) {
        label.textContent =
          text;
      }
    };


    document.addEventListener(
      'click',
      async (event) => {
        const sampleButton =
          event.target.closest(
            '[data-bp-card-sample]'
          );

        if (!sampleButton) {
          return;
        }

        event.preventDefault();

        if (sampleButton.disabled) {
          return;
        }


        const sampleMessage =
          getMessageElement(
            sampleButton
          );


        let sampleVariantId =
          Number(
            sampleButton.dataset.sampleVariant ||
            0
          );


        const sampleHandle =
          String(
            sampleButton.dataset.sampleHandle ||
            ''
          );


        sampleButton.disabled =
          true;


        setButtonLabel(
          sampleButton,
          'Muster wird hinzugefügt …'
        );


        if (sampleMessage) {
          sampleMessage.textContent =
            '';
        }


        try {
          if (!sampleVariantId && sampleHandle) {
            const sampleProductResponse =
              await fetch(
                `${root}products/${encodeURIComponent(sampleHandle)}.js`,
                {
                  headers: {
                    Accept:
                      'application/json'
                  }
                }
              );

            if (sampleProductResponse.ok) {
              const sampleProductData =
                await sampleProductResponse.json();

              const availableSampleVariant =
                (sampleProductData.variants || []).find(
                  (variant) =>
                    variant.available
                );

              sampleVariantId =
                Number(
                  availableSampleVariant?.id ||
                  0
                );
            }
          }

          if (!sampleVariantId) {
            throw new Error(
              'Für dieses Produkt ist derzeit kein verfügbares Muster hinterlegt.'
            );
          }

          const cartResponse =
            await fetch(
              cartUrl,
              {
                headers: {
                  Accept:
                    'application/json'
                }
              }
            );


          if (!cartResponse.ok) {
            throw new Error(
              'Der Musterkorb konnte nicht geladen werden.'
            );
          }


          const cart =
            await cartResponse.json();


          let samples =
            0;

          let exists =
            false;


          (cart.items || []).forEach(
            (item) => {
              const sample =
                item.properties?._bp_sample ===
                  'true' ||
                String(
                  item.handle ||
                  ''
                ).endsWith(
                  '-kostenloses-muster'
                );


              if (!sample) {
                return;
              }


              samples +=
                Number(
                  item.quantity ||
                  0
                );


              if (
                String(
                  item.handle ||
                  ''
                ) ===
                sampleHandle
              ) {
                exists =
                  true;
              }
            }
          );


          if (exists) {
            throw new Error(
              'Dieses Muster befindet sich bereits im Musterkorb.'
            );
          }


          if (samples >= 3) {
            throw new Error(
              'Du kannst maximal 3 verschiedene Bodenmuster bestellen.'
            );
          }


          const response =
            await fetch(
              cartAddUrl,
              {
                method:
                  'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json'
                },

                body:
                  JSON.stringify({
                    items: [
                      {
                        id:
                          sampleVariantId,

                        quantity:
                          1,

                        properties: {
                          'Muster von':
                            sampleButton.dataset.productTitle ||
                            '',

                          '_bp_sample':
                            'true',

                          '_bp_sample_product_id':
                            sampleButton.dataset.productId ||
                            ''
                        }
                      }
                    ]
                  })
              }
            );


          const result =
            await response.json();


          if (!response.ok) {
            throw new Error(
              result.description ||
              'Das Muster konnte nicht hinzugefügt werden.'
            );
          }


          const updatedCartResponse =
            await fetch(
              cartUrl,
              {
                headers: {
                  Accept:
                    'application/json'
                }
              }
            );


          const updatedCart =
            updatedCartResponse.ok
              ? await updatedCartResponse.json()
              : null;


          if (sampleMessage) {
            sampleMessage.textContent =
              `Muster hinzugefügt. ${samples + 1} von 3 Musterplätzen genutzt.`;
          }


          setButtonLabel(
            sampleButton,
            'Muster im Musterkorb'
          );


          document.dispatchEvent(
            new CustomEvent(
              'bodenpulse:sample-added',
              {
                detail: {
                  handle:
                    sampleHandle,

                  variantId:
                    sampleVariantId,

                  productId:
                    sampleButton.dataset.productId ||
                    '',

                  sampleCount:
                    samples +
                    1,

                  cart:
                    updatedCart
                }
              }
            )
          );


          document.dispatchEvent(
            new CustomEvent(
              'bodenpulse:sample-cart-refresh',
              {
                detail: {
                  cart:
                    updatedCart
                }
              }
            )
          );


          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                detail: {
                  cart:
                    updatedCart
                }
              }
            )
          );


          document.dispatchEvent(
            new CustomEvent(
              'cart:updated',
              {
                detail: {
                  cart:
                    updatedCart
                }
              }
            )
          );


        } catch (error) {

          if (sampleMessage) {
            sampleMessage.textContent =
              error.message;
          }


          setButtonLabel(
            sampleButton,
            'Kostenloses Muster bestellen'
          );


        } finally {

          sampleButton.disabled =
            false;

        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bodenpulse-promo-header"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncPromotion() {
    document.querySelectorAll('[data-bp-promo]').forEach(function (banner) {
      var start = Number(banner.dataset.start) * 1000;
      var end = Number(banner.dataset.end) * 1000;
      var now = Date.now();
      if (!Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end) {
        banner.remove();
        return;
      }
      window.setTimeout(function () {
        if (Date.now() >= end) banner.remove();
      }, Math.min(end - now, 2147483647));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncPromotion, { once: true });
  else syncPromotion();
  document.addEventListener('shopify:section:load', syncPromotion);
})();
  } catch(e) { console.error(e); }
})();

})();
